import { useState } from 'react'
import { Input } from '../ui/input'
import { Button } from '../ui/button'

interface PriceEditorProps {
  initialValue: number | null
  onSave: (priceString: string) => void
  onCancel: () => void
}

export function PriceEditor({ initialValue, onSave, onCancel }: PriceEditorProps) {
  const [value, setValue] = useState<string>(initialValue?.toFixed(2) || '')
  const [error, setError] = useState<string | null>(null)

  const handleSave = () => {
    if (!value.trim()) {
      onSave('')
      return
    }
    const parsed = parseFloat(value)
    if (isNaN(parsed) || parsed < 0) {
      setError('Please enter a valid positive number')
      return
    }
    onSave(value)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSave()
    else if (e.key === 'Escape') onCancel()
  }

  return (
    <div className="min-w-[100px]">
      <div className="relative">
        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground text-xs">$</span>
        <Input
          type="text"
          value={value}
          onChange={(e) => {
            const inputValue = e.target.value
            if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
              setValue(inputValue)
              setError(null)
            }
          }}
          onBlur={handleSave}
          onKeyDown={handleKeyDown}
          placeholder="0.00"
          autoFocus
          className="pl-5 py-1 h-6 text-sm min-w-[72px] w-20"
        />
      </div>
      {error && <p className="mt-1 text-destructive text-xs m-0">{error}</p>}
      <div className="flex gap-1 mt-1">
        <Button variant="secondary" size="sm" onClick={handleSave} className="h-6 px-2 text-xs">
          Save
        </Button>
        <Button variant="ghost" size="sm" onClick={onCancel} className="h-6 px-2 text-xs">
          Cancel
        </Button>
      </div>
    </div>
  )
}
